import {useState} from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import {useDispatch, useSelector} from 'react-redux';
import {enqueueSnackbar} from 'notistack';

import type {AppState} from '@jobseeker/common-core/types';
import {saveUserSettings} from '@jobseeker/common-core/reducers/user/thunkServices';
import {showErrorToast} from '@jobseeker/common-core/utils';
import {deferTask} from '@jobseeker/common-core/utils/common';

import CallPreferenceOptions from '@jobseeker/feature-profile/components/CallPreferenceOptions';
import {CALL_CONSENT_NOT_SET} from '@jobseeker/feature-profile/constants/callConsent';

const CallPreferenceSetting = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: any = useDispatch();
  const savedChoice = useSelector(
    (state: AppState) =>
      state.user.profile.settings.accountSettings?.callConsent ??
      CALL_CONSENT_NOT_SET
  );

  const [optimisticChoice, setOptimisticChoice] = useState<number>();
  const activeChoice = optimisticChoice ?? savedChoice;

  const handleChange = (value: number) => {
    if (value === activeChoice) return;
    const previousChoice = activeChoice;
    setOptimisticChoice(value);
    deferTask(async () => {
      try {
        await dispatch(
          saveUserSettings({accountSettings: {callConsent: value}})
        ).unwrap();
        enqueueSnackbar('Settings have been saved successfully.', {
          variant: 'success',
        });
      } catch (error) {
        setOptimisticChoice(previousChoice);
        showErrorToast('Failed to save settings.', error);
      }
    });
  };

  return (
    <Box display="flex" flexDirection="column" gap={1.75} maxWidth={660}>
      <Box display="flex" flexDirection="column" gap={0.5}>
        <Typography fontSize={16} fontWeight={600}>
          Who can call you about jobs
        </Typography>
        <Typography fontSize={14} color="text.secondary">
          Your number is shared only with the recruiters you approve here.
        </Typography>
      </Box>

      <CallPreferenceOptions value={activeChoice} onChange={handleChange} />

      <Divider sx={{mt: 0.5}} />
    </Box>
  );
};

export default CallPreferenceSetting;
